import classNames from 'classnames';
import { ElementType, FC } from 'react';

import { SemanticColorKey } from '../../theme/colors';
import Box, { BoxProps } from '../Box';

// Local Typings
export type TextColor =
'active' | 'branded' | 'default' | 'disabled' | 'error' | 'invert' | 'light' | 'success';

type TypographyElement = Extract<ElementType,
  | 'a'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'label'
  | 'legend'
  | 'p'
  | 'span'
  | 'strong'
>;

// todo: likely should omit fontColor from BoxProps so that we can only use specific types
// need to first update all references to fontColor on text fields
export interface TextProps extends BoxProps {
  as?: TypographyElement;
  fontFamily?: 'Gotham';
  textColor?: TextColor;
}

// Local Variables
export const defaultTextFontFamily = 'Inter, \'Helvetica Neue\', Roboto, Helvetica, Arial, sans-serif';

const fontColors: Record<TextColor, SemanticColorKey> = {
  active: 'text_active',
  branded: 'text_branded',
  default: 'text_default',
  disabled: 'text_disabled',
  error: 'text_error',
  invert: 'text_inverted',
  light: 'text_light',
  success: 'text_success',
};

// Component Definition
const Text: FC<TextProps> = ({
  fontColor,
  fontFamily,
  lineHeight = '1.5em',
  textColor = 'default',
  ...props
}) => (
  <Box
    as="p"
    fontFamily={fontFamily ? `${fontFamily}, ${defaultTextFontFamily}` : defaultTextFontFamily}
    fontWeight="normal"
    lineHeight={lineHeight}
    {...props}
    className={classNames(props.className, 'text')}
    fontColor={fontColor ?? fontColors[textColor]}
  />
);

export default Text;
